export default "__VITE_ASSET__b09842d9__"